import { render, staticRenderFns } from "./MyProsperityLogo.vue?vue&type=template&id=514c7af5&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('514c7af5')) {
      api.createRecord('514c7af5', component.options)
    } else {
      api.reload('514c7af5', component.options)
    }
    module.hot.accept("./MyProsperityLogo.vue?vue&type=template&id=514c7af5&", function () {
      api.rerender('514c7af5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/assets/icons/MyProsperityLogo.vue"
export default component.exports